import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Layout } from "@/components/Layout";
import { AuthCallback } from "@/pages/AuthCallback";

import Login from "@/pages/Login";
import HomePage from "@/pages/Home";
import MenuPage from "@/pages/Menu";
import MealDetail from "@/pages/MealDetail";
import CartPage from "@/pages/Cart";
import Planner from "@/pages/Planner";
import Builder from "@/pages/Builder";
import Children from "@/pages/Children";
import Orders from "@/pages/Orders";
import Contact from "@/pages/Contact";
import CloverTest from "@/pages/CloverTest";
import CloverReturn from "@/pages/CloverReturn";

const withLayout = (el) => (
  <ProtectedRoute>
    <Layout>{el}</Layout>
  </ProtectedRoute>
);

function AppRouter() {
  const location = useLocation();
  // Read hash from router location (reactive) to catch the OAuth session_id before anything else.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={withLayout(<HomePage />)} />
      <Route path="/menu" element={withLayout(<MenuPage />)} />
      <Route path="/meal/:id" element={withLayout(<MealDetail />)} />
      <Route path="/cart" element={withLayout(<CartPage />)} />
      <Route path="/planner" element={withLayout(<Planner />)} />
      <Route path="/builder" element={withLayout(<Builder />)} />
      <Route path="/children" element={withLayout(<Children />)} />
      <Route path="/orders" element={withLayout(<Orders />)} />
      <Route path="/contact" element={withLayout(<Contact />)} />
      <Route path="/admin/clover-test" element={withLayout(<CloverTest />)} />
      <Route path="/clover/return" element={withLayout(<CloverReturn />)} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <Toaster position="top-center" richColors />
            <AppRouter />
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
